
export default {
  name: "LazyVideoIframe",

  props: {
    src: { type: String, default: "" },
    thumbnail: { type: String, default: null },
    discreet: { type: Boolean, default: false },
  },

  data() {
    return {
      isActive: false,
      isLoading: false,
      isPlaying: false,
      isError: false,
      discreetDismissed: false,
    };
  },

  computed: {
    hasSrc() {
      return typeof this.src === "string" && this.src.trim().length > 0;
    },
    discreetActive() {
      return this.discreet && !this.discreetDismissed;
    },
    activeSrc() {
      if (!this.hasSrc) return "";
      return this.src.replace("autoplay=no", "autoplay=yes");
    },
    progressClass() {
      if (this.isLoading) return "lazy-video__progress--loading";
      if (this.isPlaying) return "lazy-video__progress--done";
      return "";
    },
  },

  methods: {
    dismissDiscreet() {
      this.discreetDismissed = true;
    },
    dismissAndPlay() {
      this.discreetDismissed = true;
      this.$nextTick(() => this.activate());
    },
    activate() {
      if (this.isLoading || !this.hasSrc) return;
      this.isActive = true;
      this.isLoading = true;
      this.isError = false;
    },
    onLoad() {
      this.isLoading = false;
      this.isPlaying = true;
    },
    onError() {
      this.isLoading = false;
      this.isActive = false;
      this.isError = true;
    },
    retry() {
      if (!this.hasSrc) return;
      this.isError = false;
      this.$nextTick(() => this.activate());
    },
  },
};
